import { NgModule, APP_INITIALIZER }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { FacturaRebCercadorComponent } from './factures-reb-cercador.component';
import { FacturesRebListComponent } from './factures-list/factures-reb-list.component';
import { FacturesRebFiltersComponent } from './factures-filtre/factures-reb-filtre.component';

import { FRListService } from './services/factures-reb-list.service';

import { FacturaRebService } from '../services/factures-reb-service/factures-reb.service';
import { InvoicesRebResumeComponent } from './invoices.resume/invoices-reb.resume.component';

import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  declarations: [
    FacturaRebCercadorComponent,
    FacturesRebListComponent,
    FacturesRebFiltersComponent,
    InvoicesRebResumeComponent
  ],
  exports:      [
    FacturaRebCercadorComponent
  ],
  providers: [
   FRListService, FacturaRebService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ]
})
export class FacturesRebSearchModule { }
